<div class="row">
<div class="col-sm-12 text-center">
<div  class="card sign-in-forms">

    <div class="text-center mt-5">
        <i class="fa fa-user fa-4x"></i>
    </div>
    <h4 class="card-header text-center">Create Account</h4>
    <h5 class="card-header text-center">{{userMessage}}</h5>
    <div class="card-body">
        <div class="alert alert-danger text-center" *ngIf="responseMessage!=''">
            {{responseMessage}}
        </div>

        <form [formGroup]="form" (ngSubmit)="onSubmit()">

            <div class="form-group input-group-lg">
                <input placeHolder="Email" type="text" formControlName="username" class="form-control" [ngClass]="{ 'is-invalid': f.username.errors && f.username.touched }" />
                <div *ngIf="f.username.errors && f.username.touched" class="invalid-feedback">
                    <div *ngIf="f.username.errors.required">Email is required</div>
                </div>
            </div>

                <div class="text-primary"><i class='fa fa-info-circle text-danger'></i> When you register, an email will be sent to you for account activation</div>

            <div class="form-group row input-group-lg mt-5">
                <div class="col-sm-6 offset-sm-3">
                <button [disabled]="loading" class="btn btn-primary btn-lg btn-block">
                    <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
                    Create Account
                </button>
            </div>
            </div>
            <div class="col-sm-8 offset-sm-2 mt-4">
            <ul class="non-style">
                <li> <i class="fa fa-caret-right"></i> Have an existing account? <a [routerLink]="['/user/login']">Login </a></li>
                <li> <i class="fa fa-caret-right mt-4"></i> Forgotten Account? <a [routerLink]="['/user/forgotten/password/email/input']">Recover Account </a></li>

            </ul>
        </div>
        </form>
    </div>
</div>
</div>
</div>
<app-country-level-syllabus></app-country-level-syllabus>

